import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { projectConstants } from '../../constants/project.constants';
import { IClinic } from './../../models/clinic.model';
import { IForm } from '../../models/form.model';
import { IUser, UserRoles } from '../../models/user.model';
import { AuthService } from '../../modules/shared/services/auth/auth.service';
import { ClinicService } from '../../modules/shared/services/clinic/clinic.service';
import { FileService } from '../../modules/shared/services/file/file.service';
import { FormService } from '../../modules/shared/services/form/form.service';
import { NavService } from '../../modules/shared/services/nav/nav.service';
import { NotificationsService } from '../../modules/shared/services/notifications/notifications.service';
import { UserService } from '../../modules/shared/services/user/user.service';
import { UtilService } from '../../modules/shared/services/util/util.service';
import { INav } from '../../_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']

})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = [];

  currentYear = new Date().getFullYear();
  projectConstants = projectConstants;
  subscriptions = new Subscription();
  UserRoles = UserRoles;

  notificationCount: number;
  defaultNavItems: INav[] = [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-home',
      isAllowAllAuthenticatedUsers: false,
    },

    {
      name: 'Reports',
      url: '/reports',
      icon: 'icon-pie-chart',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR,
        UserRoles.NURSE,
        UserRoles.LABTECH,
        UserRoles.PHYSICALTHERAPIST
      ]
    },
    {
      'title': true,
      'name': 'Patients',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR,
        UserRoles.NURSE,
        UserRoles.LABTECH,
        UserRoles.PHYSICALTHERAPIST
      ]
    },
    {
      name: 'Patients',
      url: '/patients/patients-list',
      icon: 'icon-book-open',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR,
        UserRoles.NURSE,
        UserRoles.LABTECH,
        UserRoles.PHYSICALTHERAPIST
      ]
    },
    {
      name: 'Add Patient',
      url: '/patients/patient-create',
      icon: 'icon-note',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR,
        UserRoles.NURSE,
        UserRoles.LABTECH,
        UserRoles.PHYSICALTHERAPIST
      ]
    },
    {
      name: 'Appointments',
      url: '/patients/patients-appointments',
      icon: 'icon-calendar',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR,
        UserRoles.NURSE,
        UserRoles.LABTECH,
        UserRoles.PHYSICALTHERAPIST
      ]
    },
    // {
    //   name: 'Merge Patients',
    //   url: '/patients/patients-merge',
    //   icon: 'icon-people',
    //   isAllowAllAuthenticatedUsers: true,
    //   roles: [
    //     UserRoles.SYSADMIN,
    //     UserRoles.DOCTOR,
    //     UserRoles.NURSE,
    //     UserRoles.LABTECH,
    //     UserRoles.PHYSICALTHERAPIST
    //   ]
    // },

    // {
    //   id: 'forms',
    //   name: 'Forms',
    //   icon: 'icon-folder',
    //   url: '/patients/forms',
    //   children: [],
    //   isAllowAllAuthenticatedUsers: true,
    //   roles: [
    //     UserRoles.SYSADMIN,
    //     UserRoles.DOCTOR,
    //     UserRoles.NURSE,
    //     UserRoles.LABTECH,
    //     UserRoles.PHYSICALTHERAPIST
    //   ]
    // },
    {
      'title': true,
      'name': 'Facility',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR
      ]
    },
    {
      name: 'Facilities',
      url: '/clinic',
      icon: 'icon-list',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR
      ]
    },
    {
      name: 'Add facility',
      url: '/clinic/clinic-create',
      icon: 'icon-plus',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.DOCTOR
      ]
    },

    {
      'title': true,
      'name': 'Inventory',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.INVENTORYMANAGER,
        UserRoles.PHARMACIST
      ]
    },
    {
      name: 'Inventory Items',
      url: '/inventory/items-list',
      icon: 'fas fa-truck-loading',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.INVENTORYMANAGER,
        UserRoles.PHARMACIST
      ]
    },
    {
      name: 'Inventory Transaction',
      url: '/inventory/inventory-item-quantity-all',
      icon: 'fas fa-dolly-flatbed',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.INVENTORYMANAGER,
        UserRoles.PHARMACIST
      ]
    },

    {
      'title': true,
      'name': 'Admin',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.USERMANAGER,
      ]
    },
    {
      name: 'Inventory Category',
      url: '/inventory/category',
      icon: 'fas fa-boxes',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN
      ]
    },
    {
      name: 'Users',
      url: '/users/users-list',
      icon: 'icon-people',
      linkProps: { routerLinkActiveOptions: { exact: true } },
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.USERMANAGER
      ]
    },
    {
      name: 'Add User',
      url: '/users/add-user',
      icon: 'icon-user-follow',
      linkProps: { routerLinkActiveOptions: { exact: true } },
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.USERMANAGER
      ]
    },
    {
      name: 'Approve Users',
      url: '/users/approve-user',
      icon: 'fas fa-user-check',
      linkProps: { routerLinkActiveOptions: { exact: true } },
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
        UserRoles.USERMANAGER
      ]
    },
    {
      name: 'Manage Forms',
      url: '/forms',
      icon: 'icon-layers',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN,
      ]
    },
    {
      name: 'Menu Items',
      url: '/nav/nav-items',
      icon: 'icon-menu',
      linkProps: { routerLinkActiveOptions: { exact: true } },
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN
      ]
    },
    // {
    //   name: 'User Roles',
    //   url: '/users/user-roles',
    //   icon: 'icon-lock',
    //   linkProps: {routerLinkActiveOptions: {exact: true}},
    //   isAllowAllAuthenticatedUsers: true,
    //   roles: [
    //     UserRoles.SYSADMIN,
    //     UserRoles.USERMANAGER
    //   ]
    // },
    {
      name: 'Visits',
      url: '/dashboard/visits',
      icon: 'far fa-hospital',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.PATIENT
      ]
    },
    {
      name: 'Appointments',
      url: '/dashboard/appointments',
      icon: 'icon-calendar',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.PATIENT
      ]
    },
    {
      name: 'Facilities',
      url: '/dashboard/clinics',
      icon: 'icon-list',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.PATIENT
      ]
    },
    {
      name: 'Trash',
      url: '/trash',
      icon: 'icon-trash',
      isAllowAllAuthenticatedUsers: true,
      roles: [
        UserRoles.SYSADMIN
      ]
    },
  ];
  clinics: IClinic[] = [];
  isLoadingClinics = false;
  clinicTableColumns: string[] = [
    'name',
    'location'
  ];
  modalReference: any;
  user: IUser;
  profilePicture: any;

  constructor(
    private authService: AuthService,
    private formService: FormService,
    private navService: NavService,
    private modalService: NgbModal,
    private clinicService: ClinicService,
    private notificationService: NotificationsService,
    private utilService: UtilService,
    private userService: UserService,
    private fileService: FileService
  ) {
    // this.notificationService.notificationCount.subscribe((res: any) => {
    //   this.notificationCount = res;
    //   console.log(this.notificationCount +' default page')

    // });
  }

  ngOnInit(): void {
    this.checkIfUserIsANewUser();
    // this.createNavItems();
    // this.deleteAllNavItems();
    this.getUserDetails();
    this.getUserProfilePictureMetaData();
    this.triggerGetNotificationService();
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logout(): void {
    this.authService.logout();
  }

  checkIfUserIsANewUser(): void {
    if (!this.authService.isUserANewUser()) {
      this.getAllNavItems();
    }
  }

  getAllNavItems(): void {
    this.subscriptions.add(
      this.navService.getAllNavItems().subscribe({
        next: (res) => {
          const navItems = res.result;
          this.navItems = navItems;
          // this.getAllPatientForms(navItems);
        }
      })
    );
  }

  getAllPatientForms(navItems: INav[]): void {
    this.subscriptions.add(
      this.formService.getFormsByRole().subscribe({
        next: (res) => {
          if (res?.result?.length === 0) {
            this.navItems = navItems;
          } else {
            this.updateMenuWithForms(navItems, res.result);
          }
        }
      })
    );
  }

  updateMenuWithForms(navItems: INav[], patientForms: IForm[]): void {
    const formsFieldsIndex = navItems.findIndex(x => x.name.toLowerCase() === 'forms');
    let children = [];
    if (formsFieldsIndex !== -1) {
      for (let i = 0; i < patientForms.length; i++) {
        const form = patientForms[i];
        const formMenuItem = {
          name: form?.name,
          url: '/patients/select-patient/' + form?._id,
          icon: 'icon-notebook'
        };
        children = [...children, formMenuItem];
      }
      const formField = {
        ...navItems[formsFieldsIndex],
        children
      };
      navItems[formsFieldsIndex] = formField;
      this.navItems = navItems;
    }
  }

  createNavItems(): void {
    this.subscriptions.add(
      this.navService.createNavItems(this.defaultNavItems).subscribe({
        next: (res) => {
          this.getAllNavItems();
        }
      })
    );
  }

  deleteAllNavItems(): void {
    this.subscriptions.add(
      this.navService.deleteAllNavItems().subscribe({
        complete: () => this.navItems = []
      })
    );
  }

  getUserName(): string {
    const decodedToken = this.authService.decodedToken();
    const userName = decodedToken.username;
    return userName ? userName : '';
  }

  open(content) {
    this.modalReference = this.modalService.open(content);
  }

  getAllClinics(): void {
    this.isLoadingClinics = true;
    this.subscriptions.add(
      this.clinicService.getAllClinics().subscribe({
        next: (res) => {
          this.isLoadingClinics = false;
          this.clinics = res.result;
        },
        error: () => this.isLoadingClinics = false
      })
    );
  }

  setDefaultClinic(clinicId: string): void {
    this.subscriptions.add(
      this.userService.setUserDefaultClinic(clinicId).subscribe({
        complete: () => this.modalReference.close()
      })
    );
  }

  getUserDetails(): void {
    this.subscriptions.add(
      this.userService.getUserProfile().subscribe({
        next: (res) => {
          this.user = res.result;
        }
      })
    );
  }

  getUserProfilePictureMetaData(): void {
    this.subscriptions.add(
      this.userService.getProfilePictureMetaData().subscribe({
        next: (res) => {
          if (res.result?.fileId) {
            this.getProfileImage(res.result.fileId);
          }
        }
      })
    );
  }

  getProfileImage(fileId: string): void {
    this.subscriptions.add(
      this.fileService.downloadImageFile(fileId).subscribe({
        next: (res) => {
          this.createImageFromBlob(res);
        }
      })
    );
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.profilePicture = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  triggerGetNotificationService(): void {
    this.subscriptions.add(
      this.notificationService.getNotificationsCount().subscribe({
        complete: () => {
          this.getNotificationCount();
        }
      })
    );
  }

  getNotificationCount(): void {
    this.notificationService.unreadNotificationCount.subscribe({
      next: (res) => {
        this.notificationCount = res;
      }
    })
  }
}
